<!-- 表1填写 -->

<template>
  <div class="tabCage table1">
    <div class="tabTtl">
      <span>表 1-1：基本情况表</span>
      <!-- <el-select v-model="value" clearable placeholder="历史版本列表" class="selectTime" @change="gethistory(value)">
				 <el-option
						 v-for="item in options"
						 :key="item.id"
						 :label="item.value"
						 :value="item.id">
				 </el-option>
			 </el-select> -->
    </div>
    <div class="headBar">
      <span>工商营业执照或事业法人证书信息</span>
    </div>
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea editBox">
        <table :class="value !== '' ? 'newStyle' : ''">
          <tr>
            <td class="edName">单位名称：</td>
            <td class="edInpBig">
              <el-form-item prop="publishName" :inline-message="true">
                <el-input style="width: 600px" v-model="params.publishName" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">统一社会信用代码：</td>
            <td class="edInp">
              <el-input v-model="params.usccNum" disabled size="small"></el-input>
            </td>
          </tr>
          <!-- <tr>
            <td class="edName">名称：</td>
            <td class="edInp">
              <el-input style="width:600px" v-model="params.usccOrgName" disabled size="small"></el-input>
            </td>
          </tr> -->
          <tr>
            <td class="edName">类型：</td>
            <td class="edInp">
              <el-select v-model="params.usccType" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C001']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">住所：</td>
            <td class="edInp">
              <el-input v-model="params.residence" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">法定代表人：</td>
            <td class="edInp">
              <el-input v-model="params.faren" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">注册资本或开办资金（万元）：</td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="2"
                v-model="params.yyzzZczb"
                disabled
                :controls="false"
                size="small"></el-input-number>
            </td>
          </tr>
          <tr>
            <td class="edName">成立日期：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="params.clDate"
                align="right"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">营业日期：</td>
            <td class="edInp areaTime">
              <el-date-picker
                disabled
                v-model="params.areaDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                size="small"
                style="width: 635px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <!-- <el-form-item prop="params.startYyDate" :inline-message="true">
                <el-date-picker
                  disabled
                  v-model="params.startYyDate"
                  value-format="yyyy-MM-dd"
                  style="width: 133px"
                  placeholder="开始日期"
                  size="small">
                </el-date-picker>
              </el-form-item>
              <span class="midSpan">至</span>
              <el-date-picker
                disabled
                v-model="params.endYyDate"
                value-format="yyyy-MM-dd"
                style="width: 133px"
                placeholder="结束日期"
                size="small">
              </el-date-picker> -->
            </td>
          </tr>
          <tr>
            <td class="edName">经营范围或业务范围：</td>
            <td class="edInpTextArea">
              <el-input type="textarea" :rows="8" v-model="params.yyfw" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">登记日期：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="params.djDate"
                align="right"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">证照编号：</td>
            <td class="edInp">
              <el-input disabled v-model="params.usccCode" size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName uploadLine">营业执照或事业法人证书：</td>
            <td class="edInp">
              <div class="imgfram">
                <!-- <img @click="dialogVisible = true" :src="imgUrl" alt=""> -->
                <img width="250" @click="dialogVisible = true" :src="imgUrl" alt="" />
              </div>

              <!-- <Upbtn :ableSure="imgId" @upFileId="fileTdSet"  />
                       <div class="tips">注：上传文件格式为JPGE/PNG，文件大小不超过10M</div>   -->
            </td>
          </tr>
        </table>
        <table :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
          <tr>
            <td class="edName">单位名称：</td>
            <td class="edInp">
              <el-form-item prop="publishName" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="historyJsonParams.publishName"
                  disabled
                  size="small"
                  :class="historyJsonParams.publishName !== params.publishName ? 'highlight' : ''"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">统一社会信用代码：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.usccNum"
                disabled
                size="small"
                :class="historyJsonParams.usccNum !== params.usccNum ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">名称：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.usccOrgName"
                disabled
                size="small"
                :class="historyJsonParams.usccOrgName !== params.usccOrgName ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">类型：</td>
            <td class="edInp">
              <el-select
                v-model="historyJsonParams.usccType"
                disabled
                size="small"
                placeholder="请选择"
                :class="historyJsonParams.usccType !== params.usccType ? 'highlight' : ''">
                <el-option v-for="item in dicDats['C001']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">住所：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.residence"
                disabled
                size="small"
                :class="historyJsonParams.residence !== params.residence ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">法定代表人：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.faren"
                disabled
                size="small"
                :class="historyJsonParams.faren !== params.faren ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">注册资本或开办资金（万元）：</td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="2"
                v-model="historyJsonParams.yyzzZczb"
                disabled
                size="small"
                :class="historyJsonParams.yyzzZczb !== params.yyzzZczb ? 'highlight' : ''">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td class="edName">成立日期：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="historyJsonParams.clDate"
                align="right"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :class="historyJsonParams.clDate !== params.clDate ? 'highlight' : ''">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">营业日期：</td>
            <td class="edInp">
              <!-- <el-date-picker disabled v-model="historyJsonParams.areaDate" value-format="yyyy-MM-dd" type="daterange"
                size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :class="historyJsonParams.areaDate!==params.areaDate?'highlight':''">
              </el-date-picker> -->
              <el-form-item prop="historyJsonParams.startYyDate" :inline-message="true">
                <el-date-picker
                  disabled
                  v-model="historyJsonParams.startYyDate"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  size="small">
                </el-date-picker>
              </el-form-item>
              <span class="midSpan">至</span>
              <el-date-picker
                disabled
                v-model="historyJsonParams.endYyDate"
                value-format="yyyy-MM-dd"
                placeholder="结束日期"
                size="small">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">经营范围或业务范围：</td>
            <td class="edInp">
              <el-input
                type="textarea"
                :rows="3"
                v-model="historyJsonParams.yyfw"
                disabled
                size="small"
                :class="historyJsonParams.yyfw !== params.yyfw ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">登记日期：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="historyJsonParams.djDate"
                align="right"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :class="historyJsonParams.djDate !== params.djDate ? 'highlight' : ''">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">证照编号：</td>
            <td class="edInp">
              <el-input
                disabled
                v-model="historyJsonParams.usccCode"
                size="small"
                :class="historyJsonParams.usccCode !== params.usccCode ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName uploadLine">营业执照或事业法人证书：</td>
            <td class="edInp">
              <div class="imgfram">
                <img @click="dialogVisible = true" :src="historyImgUrl" alt="" />
              </div>

              <!-- <Upbtn :ableSure="imgId" @upFileId="fileTdSet"  />
                <div class="tips">注：上传文件格式为JPGE/PNG，文件大小不超过10M</div>   -->
            </td>
          </tr>
        </table>
      </div>

      <div class="headBar">
        <span>单位基本信息</span>
      </div>

      <div class="editArea">
        <table :class="value !== '' ? 'newStyle' : ''">
          <tr>
            <td class="edName">企业性质：</td>
            <td class="edInp edSelect">
              <el-select v-model="params.nature" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C001']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>

              <el-input
                disabled
                size="small"
                v-if="CompanyNatureMap[params.nature] == '其他'"
                v-model="params.otherNature"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">是否为独立法人：</td>
            <td class="edInp">
              <el-select v-model="params.isIndependentLP" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
              <div class="tips">注：以音像电子业务为主体业务的独立法人单位填写"是"，其他单位填写"否"</div>
            </td>
          </tr>
          <tr v-if="layDasion == 1">
            <td class="edName">独立法人单位类型：</td>
            <td class="edInp">
              <el-select v-model="params.unitType" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C019']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr v-if="layDasion == 1">
            <td class="edName">独立法人隶属关系：</td>
            <td class="edInp">
              <el-select v-model="params.independentLPSituation" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C003']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr v-if="layDasion == 2">
            <td class="edName">非独立法人隶属关系：</td>
            <td class="edInp">
              <el-select v-model="params.nonIndependentLPSituation" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C004']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-input style="width: 600px" v-model="params.publishAddr" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-input v-model="params.publishPostalcode" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-input v-model="params.publishLinkman" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-input v-model="params.publishTel" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-input v-model="params.publishPhone" disabled size="small"></el-input>
            </td>
          </tr>

          <tr>
            <td class="edName">单位职工总数：</td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  disabled
                  v-model="params.workers"
                  :min="0"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">
              从事<span v-if="pressType == 1">音像</span> <span v-else-if="pressType == 2">电子</span>业务人员数：
            </td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  disabled
                  v-model="params.businessWorkers"
                  :min="0"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">其他人员数：</td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  disabled
                  v-model="params.otherWorkers"
                  :min="0"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">资产总额（万元）：</td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  disabled
                  v-model="params.totalAssets"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">负债总额（万元）：</td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  disabled
                  v-model="params.totalLiabilities"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">备注：</td>
            <td class="edInpTextArea">
              <el-form-item prop="remark" :inline-message="true">
                <el-input type="textarea" :rows="5" v-model="params.remark" placeholder="" disabled size="small">
                </el-input>
              </el-form-item>
              <!-- <div class="tips">注：请填写出版单位其他需要说明的相关信息，如没有不填写</div> -->
            </td>
          </tr>
        </table>
        <table :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
          <tr>
            <td class="edName">企业性质：</td>
            <td class="edInp">
              <el-select
                v-model="historyJsonParams.nature"
                disabled
                size="small"
                placeholder="请选择"
                :class="historyJsonParams.nature !== params.nature ? 'highlight' : ''">
                <el-option v-for="item in dicDats['C001']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
              <el-input
                v-if="CompanyNatureMap[params.nature] == '其他'"
                size="small"
                disabled
                v-model="params.otherNature"
                placeholder="若企业性质为“其他”，请输入"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">是否为独立法人：</td>
            <td class="edInp">
              <el-select
                v-model="historyJsonParams.isIndependentLP"
                disabled
                size="small"
                placeholder="请选择"
                :class="historyJsonParams.isIndependentLP !== params.isIndependentLP ? 'highlight' : ''">
                <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
              <div class="tip-red">以音像电子业务为主体业务的独立法人单位填写“是”，其他单位填写“否”</div>
            </td>
          </tr>
          <tr v-if="layDasion == 1">
            <td class="edName">独立法人单位类型：</td>
            <td class="edInp">
              <el-select
                v-model="historyJsonParams.unitType"
                disabled
                size="small"
                placeholder="请选择"
                :class="historyJsonParams.unitType !== params.unitType ? 'highlight' : ''">
                <el-option v-for="item in dicDats['C019']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr v-if="layDasion == 1">
            <td class="edName">独立法人隶属关系：</td>
            <td class="edInp">
              <el-select
                v-model="historyJsonParams.independentLPSituation"
                disabled
                size="small"
                placeholder="请选择"
                :class="historyJsonParams.independentLPSituation !== params.independentLPSituation ? 'highlight' : ''">
                <el-option v-for="item in dicDats['C003']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr v-if="layDasion == 2">
            <td class="edName">非独立法人隶属关系：</td>
            <td class="edInp">
              <el-select
                v-model="historyJsonParams.nonIndependentLPSituation"
                disabled
                size="small"
                placeholder="请选择"
                :class="
                  historyJsonParams.nonIndependentLPSituation !== params.nonIndependentLPSituation ? 'highlight' : ''
                ">
                <el-option v-for="item in dicDats['C004']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-input
                style="width: 600px"
                v-model="historyJsonParams.publishAddr"
                disabled
                size="small"
                :class="historyJsonParams.publishAddr !== params.publishAddr ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.publishPostalcode"
                disabled
                size="small"
                :class="historyJsonParams.publishPostalcode !== params.publishPostalcode ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.publishLinkman"
                disabled
                size="small"
                :class="historyJsonParams.publishLinkman !== params.publishLinkman ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.publishTel"
                disabled
                size="small"
                :class="historyJsonParams.publishTel !== params.publishTel ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.publishPhone"
                disabled
                size="small"
                :class="historyJsonParams.publishPhone !== params.publishPhone ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="numLine" colspan="2">
              <div class="numInp">
                <div class="inpName">单位职工总数：</div>
                <div class="inpText">
                  <el-input-number
                    controls-position="right"
                    disabled
                    v-model="historyJsonParams.workers"
                    :min="0"
                    size="small"
                    :class="historyJsonParams.workers !== params.workers ? 'highlight' : ''"></el-input-number>
                </div>
              </div>
              <div class="numInp">
                <div class="inpName">
                  从事<span v-if="pressType == 1">音像</span> <span v-else-if="pressType == 2">电子</span>业务人员数：
                </div>
                <div class="inpText">
                  <el-input-number
                    controls-position="right"
                    disabled
                    v-model="historyJsonParams.businessWorkers"
                    :min="0"
                    size="small"
                    :class="historyJsonParams.businessWorkers !== params.businessWorkers ? 'highlight' : ''">
                  </el-input-number>
                </div>
              </div>
              <div class="numInp">
                <div class="inpName">其他人员数：</div>
                <div class="inpText">
                  <el-input-number
                    controls-position="right"
                    disabled
                    v-model="historyJsonParams.otherWorkers"
                    :min="0"
                    size="small"
                    :class="historyJsonParams.otherWorkers !== params.otherWorkers ? 'highlight' : ''">
                  </el-input-number>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="numLine" colspan="2">
              <!-- <div class="numInp">
                <div class="inpName">注册资本（万元）：</div>
                <div class="inpText">
                  <el-input-number
                    controls-position="right"
                    v-model="historyJsonParams.registeredCapital"
                    :min="0"
                    :precision="2"
                    disabled
                    size="small"
                    :class="historyJsonParams.registeredCapital !== params.registeredCapital ? 'highlight' : ''">
                  </el-input-number>
                </div>
              </div> -->
              <div class="numInp">
                <div class="inpName">资产总额（万元）：</div>
                <div class="inpText">
                  <el-input-number
                    controls-position="right"
                    v-model="historyJsonParams.totalAssets"
                    :min="0"
                    :precision="2"
                    disabled
                    size="small"
                    :class="historyJsonParams.totalAssets !== params.totalAssets ? 'highlight' : ''">
                  </el-input-number>
                </div>
              </div>
              <div class="numInp">
                <div class="inpName">负债总额（万元）：</div>
                <div class="inpText">
                  <el-input-number
                    controls-position="right"
                    v-model="historyJsonParams.totalLiabilities"
                    :min="0"
                    :precision="2"
                    disabled
                    size="small"
                    :class="historyJsonParams.totalLiabilities !== params.totalLiabilities ? 'highlight' : ''">
                  </el-input-number>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="edName">备注：</td>
            <td class="edInp spMake">
              <el-form-item prop="remark" :inline-message="true">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="historyJsonParams.remark"
                  placeholder=""
                  disabled
                  size="small"
                  :class="historyJsonParams.remark !== params.remark ? 'highlight' : ''"></el-input>
              </el-form-item>
              <!-- <div class="tips">注：请填写出版单位其他需要说明的相关信息，如没有不填写</div> -->
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea editBox">
        <table :class="value !== '' ? 'newStyle' : ''">
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input v-model="declare.personnel" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input v-model="declare.contact" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input v-model="params.updatedAt" disabled size="small"></el-input>
            </td>
          </tr>
        </table>
        <table :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input
                v-model="historyDeclare.personnel"
                disabled
                size="small"
                :class="historyDeclare.personnel !== declare.personnel ? 'highlight' : ''">
              </el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input
                v-model="historyDeclare.contact"
                disabled
                size="small"
                :class="historyDeclare.contact !== declare.contact ? 'highlight' : ''">
              </el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input
                v-model="historyDeclare.updatedAt"
                disabled
                size="small"
                :class="historyDeclare.updatedAt !== params.updatedAt ? 'highlight' : ''">
              </el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="imgUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt1";
import { tabRead1, pSubmitHistoryList } from "@/api/pressRole/pressRole";
import { getPfileUrl } from "@/api/pressRole/pressRole";
import { detFile } from "@/api/account";
import { getFileToken } from "@/api/account";
import Upbtn from "@/views/components/uploadCards";
export default {
  components: {
    Upbtn,
  },
  data() {
    return {
      pressType: this.$route.query.pressType,
      dialogVisible: false,
      params: bsParams,
      rules: paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 1,
      imgId: "",
      imgUrl: "",
      options: [],
      value: "",
      getImg: "",
      historyJson: [],
      historyJsonParams: {}, // 提交的历史数据json
      historyImgUrl: "", // 提交的历史数据里的img地址
      declare: {
        personnel: "",
        contact: "",
      },
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: "",
      },
      CompanyNatureMap: {},
    };
  },
  watch: {
    "params.areaDate": function (dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    },
  },
  methods: {
    dictInit: function () {
      let nameArr = ["C001", "C018", "C019", "C003", "C004"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });
      let vm = this;
      newPromise.then((result) => {
        this.dicDats = result;
        this.isNot = this.$store.getters.dictionary["C018"];
        vm.CompanyNatureMap = vm.$store.getters.dictionary["C001"];
        for (let key in this.isNot) {
          if (this.isNot[key] == "是") {
            this.params.isIndependentLP = key;
          }
        }
      });
    },

    tabReEdit: function () {
      let vm = this;
      tabRead1({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        response.pbasic.areaDate = [response.pbasic.startYyDate, response.pbasic.endYyDate];
        this.params = response.pbasic;
        this.imgId = response.pbasic.yyzzId;
        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        this.layChange();
        // getFileToken().then(inresp => {
        //   this.imgUrl = process.env.BASE_API + '/File/File/download/token/' + inresp.resultStatus.token +
        //     '/id/' + vm.imgId;
        // })
        // zym.设置营业执照或事业法人证书
        getPfileUrl({ id: response.pbasic.yyzzId }).then((response) => {
          let url = response.payload.url;
          this.dialogVisible = false;
          this.imgUrl = url;
        });
      });
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function () {
      let that = this;
      pSubmitHistoryList({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        that.historyJson = response.pSubmitHistoryList;

        for (const list of response.pSubmitHistoryList) {
          that.options.push({
            value: list.createdAt,
            id: list.id,
          });
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function (id) {
      const that = this;
      for (const list of that.historyJson) {
        if (id == list.id) {
          that.historyJsonParams = JSON.parse(list.afterJson);
          that.historyDeclare = JSON.parse(list.submittor);
        }
      }
      // 获取图片
      getFileToken().then((data) => {
        that.historyImgUrl =
          process.env.BASE_API +
          "/File/File/download/token/" +
          data.resultStatus.token +
          "/id/" +
          that.historyJsonParams.yyzzId;
      });
    },

    fileTdSet: function (id) {
      this.params.yyzzId = id;
    },

    layChange: function () {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },
    // 返回上一页
    goBack: function () {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getHistoryList();
  },
  created: function () {
    let pathArr = this.$route.path.split("/");
    this.dictInit();
    this.tabReEdit();
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.highlight {
  .el-input__inner,
  .el-textarea__inner {
    color: red !important;
  }
}

.newStyle {
  margin: 30px 0 !important;
  width: 50% !important;
  overflow: hidden;
  float: left;
}

.table1 {
  margin-top: 0px;

  .editBox {
    overflow: hidden;
  }

  .editArea table .edName {
    width: 210px;
  }

  .imgfram {
    height: 120px;
  }

  .imgfram img {
    height: 120px;
    margin-top: 9px;
    cursor: pointer;
  }

  .selectTime {
    float: right;
    font-weight: normal;
  }
}

.table1 .uploadLine {
  vertical-align: text-top;
  padding-top: 5px;
}

.table1 .numLine {
  padding-bottom: 15px;
}

.table1 .numInp {
  display: block !important;
}

.table1 .numInp .inpName {
  display: inline-block;
  width: 210px;
  text-align: right;
  padding-bottom: 15px;
}

.table1 .numInp .inpText {
  display: inline-block;
  padding-left: 12px;
}

.table1 .numInp .inpText input {
  border-radius: 0px;
}

.el-date-editor {
  border-radius: 0px;
}

.table1 .el-textarea {
  width: 350px;
}

.table1 .edInp .el-input-number {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// table1.vue?30e7cc94